<template>
  <div id="SOVDetailNewAMDIndia" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap  card revampCard" style="flex-direction: row">
  		<div class="leftcontent wrapitem">
  		  <div class="datebox customSelect">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.hp.com/in-en">HP India</option>
            <option value="https://www.hp.com/in-en#commercial">Commercial HP India</option>
          </select>
        </div>
      	<div class="datebox" v-show='false'>
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate2" />
  	 		</div>
        <div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  			
  	 	
        <div class="datebox" style="width:10%">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
          </select>
        </div>
  	 		<div class="datebox" >
          <button @click="refresh" class="btn primarycolor" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
        
  	 	</div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float:right">
          <button @click="backToSov" style="width: max-content; float: right" class="navigationButton" type="button">
            <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon" />
            <span> Back</span>
          </button>
        </div>
      </div>
     
  	</div>
    <div class="container-fluid ">
      <!-- <div  style="display: flow-root;">
        <button  style="margin-bottom:10px" class="weavrpurple" @click="filterAddAction" v-if="!addFilter">Add Filter</button>
         <button @click="exportNow" style="margin-bottom:10px;float:right" class="weavrpurple" >Export</button>
      </div> -->
      <!-- <div v-if="addFilter" class="card p-2 filter" style="padding: 21px!important;background: #f5f5f5">
        <div class="row mt-2" v-for="(d,i) in filterRow">
          <div class="col-md-2 pr-0">
            <select v-model="d.filterKey" class="form-control text-uppercase">
             <option value="price">Price</option>
             <option value="reviews">Reviews</option>
             <option value="ratings">Ratings</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
            <select v-model="d.filterCondition" class="form-control text-uppercase">
              <option value="equals">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
           <input v-model="d.val1" class="form-control filval" type="text" placeholder="">
           <input v-if="d.filterCondition == 'between'" v-model="d.val2" class="form-control filval mt-2" type="text" placeholder="">
          </div>
       
          <div  class="col-md-2">
            <button @click="filterRemove(i)" class="btn filval btn-danger"> Remove </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 pt-4" style="text-align: center;">
            <button @click="filterApply" class="btn filval btn-primary mr-2">Apply Filter</button>
            <button v-if="filterRow.length < 3" @click="filterAddMore" class="btn filval btn-success mr-2"> Add more </button>
            <button class="btn filval btn-danger " @click="filterCancel"> Cancel </button>
          </div>
          
        </div>
      </div> -->
      <div class="">
        <div class="card p-2">
         
          <table id="myTable2" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['processor'] == 'amd',
                'markitintel':r['processor'] == 'intel','markitsnap':r['processor'] == 'qualcomm snapdragon','markitna':r['processor'] == 'N/A',
                'markittek':r['processor'] == 'mediatek'}">
                <td :data-order="getDataOrder(r[d.field])" v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span v-if="d.field == 'processor' && r['processor']== 'amd' ">{{r[d.field].toUpperCase() }}</span>  
                      <span v-else>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'SOVDetailNewAMDIndia',
  components: { Datepicker },
  watch: {
    selected_website(){
      this.device='laptop'
    }
  },
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      device:'laptop',
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD'),
        startDate2: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      oem_websites:['https://www.bechtle.com','https://www.connection.com','https://www.shi.com','https://www8.hp.com/jp#commercial','https://www.lenovo.com/jp#commercial','https://b2b.lenovo.com.cn#commercial','https://www.hpstore.cn#commercial','https://www.nec-lavie.jp','https://fmv.fccl.fujitsu.com','https://www.dell.com/ja-jp','https://www.dell.com/en-au','https://www.lenovo.com/au','https://br-store.acer.com','https://s.lenovo.com.cn','https://store.hp.com/FranceStore','https://store.hp.com/mx-es','https://www.lenovo.com/fr','https://www.insight.com/en-US','https://store.hp.com/FranceStore#commercial','https://www.lenovo.com/fr#commercial','https://www.cdw.com','https://www.lenovo.com/gb#commercial','https://store.hp.com/UKStore#commercial','https://www.lenovo.com/de#commercial','https://store.hp.com/GermanyStore#commercial','https://www8.hp.com/jp','https://store.hp.com/us#commercial','https://www.lenovo.com/us#commercial','https://store.hp.com/UKStore','https://store.hp.com/us','https://www.asus.com/fr','https://store.asus.com/us','https://www.dell.com/en-us','https://store.acer.com/en-us','https://www.lenovo.com/us','https://www.lenovo.com/gb','https://www.lenovo.com/de'],
      columns_details:[],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      deviceMapper:{
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      filterRow: [],
      addFilter:false,
      filterKey: 'price',
      filterCondition: 'equals',
      filterVal1: '',
      filterVal2: '',
      websiteName: {
        "https://www.amazon.com": "Amazon US",
        "https://www.harveynorman.com.au": "Harvey Norman AU",
        "https://www.bestbuy.com": "Best Buy US",
        "https://www.currys.co.uk": "Curry's UK",
        "https://www.costco.com": "Costco US",
        "https://www.walmart.com": "Walmart US",
        "https://store.hp.com/us": "HP US",
        "https://global.jd.com": "JD GC",
        "https://store.asus.com/us": "ASUS US",
        "https://www.dell.com/en-us": "Dell US",
        "https://store.acer.com/en-us": "Acer US",
        "https://store.hp.com/UKStore":"HP UK",
        "https://www8.hp.com/jp": "HP Japan",
        "https://www.lenovo.com/us":"Lenovo US",
        "https://www.lenovo.com/gb":"Lenovo UK",
        "https://www.lenovo.com/de":"Lenovo Germany",
        "https://www.mediamarkt.de": "MediaMarkt DE",
        "https://store.hp.com/us#commercial": "Commercial HP US",
        "https://www.lenovo.com/us#commercial": "Commercial Lenovo US",
        "https://www.lenovo.com/de#commercial": "Commercial Lenovo Germany ",
        "https://store.hp.com/GermanyStore#commercial": "Commercial HP Germany",
        "https://www.cdw.com":"CDW",
        "https://www.insight.com/en-US":"Insight",
        "https://www.lenovo.com/fr#commercial": 'Commercial Lenovo France',
        "https://store.hp.com/FranceStore#commercial": "Commercial HP France",
        "https://store.hp.com/UKStore#commercial": 'Commercial HP UK',
        "https://www.lenovo.com/gb#commercial": "Commercial Lenovo UK",
        "https://www.lenovo.com/fr": 'Lenovo France',
        'https://store.hp.com/mx-es': 'HP Mexico',
        "https://store.hp.com/FranceStore": 'HP France',
        "https://br-store.acer.com": 'Acer Brazil',
        "https://www.lenovo.com/au": 'Lenovo Australia',
        "https://s.lenovo.com.cn": 'Lenovo China',
        "https://www.asus.com/fr":'Asus France',
        "https://www.dell.com/en-au": "Dell Australia",
        "https://www.dell.com/ja-jp": "Dell Japan",
        'https://fmv.fccl.fujitsu.com': 'Fujitsu Japan',
        'https://www.nec-lavie.jp': 'NEC Japan',
        'https://www.hpstore.cn#commercial': 'Commercial HP China',
        'https://www.lenovo.com/jp#commercial': 'Commercial Lenovo Japan',
        'https://b2b.lenovo.com.cn#commercial': 'Commercial Lenovo China',
        'https://www8.hp.com/jp#commercial': 'Commercial HP Japan',
        'https://www.shi.com': 'SHI',  
        'https://www.connection.com': 'PC Connection',  
        'https://www.bechtle.com': 'Bechtle'
      }
    }
  },
  mounted()
  {
    if(localStorage.selected_category)
    {
      this.device = localStorage.selected_category
    }
    this.website_details()
    this.initCols()
  },
  methods: {
    goToSOVDetailReport(){
      window.location = '#/sov-detail-report'
    },
    exportNow(){
      let self = this
      self.loader = true
      let payload = {}
      payload.website = this.selected_website
      payload.item_category = self.device
      payload.timestamp = self.date.startDate
      payload.website_name = self.websiteName[self.selected_website]
      const url = "/api/websites/sov_details/download"
      this.$http.post(url, payload).then(response => {
        self.loader = false
        window.location = response.body.data
      }, err => {
        self.loader = false
      });
    },
    getDataOrder(d){
      if((typeof(d)=='string') && (d.includes('.–')))
      {
        return '<span>' + d.replace('.–','') + '</span>'
      }
      return '<span>' + d + '</span>'

    },
    filterCancel(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.addFilter = false
      this.filterRow = []
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  

    },
    filterRemove(i){
      this.filterRow.splice(i,1)
    },
    filterAddAction(){
      this.addFilter = true
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)
    },
    filterAddMore(){
      let obj = {}
      obj.filterKey = 'price'
      obj.filterCondition = 'equals'
      obj.val1 = ''
      obj.val2 = ''
      this.filterRow.push(obj)

    },

    filterCheck(dataset){
      
      let operators = {
        'equals': function(a, b, c) { return a==b },
        'gt': function(a, b, c) { return a > b },
        'gte': function(a, b, c) { return a >= b },
        'lt': function(a, b, c) { return a < b },
        'lte': function(a, b, c) { return a <= b },
        'between': function(a, b, c) { 
          if(!c)
            return a >= b
          if(!b)
            return (a <= c)
          
          return ((a >= b)&&(a <= c)) },
      }
      for(let [fi, fd] of this.filterRow.entries()) 
      {
        if(!fd.val1)
        {
          if(fi==this.filterRow.length-1)
          {
            return true
          }
          else
          {
            continue
          }
        }

        if (typeof(dataset[fd.filterKey])=='string')
          dataset[fd.filterKey] = dataset[fd.filterKey].replace('.–','').replace('$','').replace(" ",'').replace(",",'').replace(",",'')
        dataset[fd.filterKey] = parseFloat(dataset[fd.filterKey])
        dataset[fd.val1] = parseFloat(dataset[fd.val1])  
        dataset[fd.val2] = parseFloat(dataset[fd.val2])  
        if (operators[fd.filterCondition](dataset[fd.filterKey], fd.val1, fd.val2  ) == false)
        {
          return false
        }
      }
      return true

    },
    filterApply(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(this.filterCheck(dataset))
        {
          this.rows_details.push(dataset)
        }
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
    initCols(){
      if(this.oem_websites.includes(this.selected_website)){
        this.columns_details = [ 
          {label: 'Location', field: 'location',sortable: false},
          {label: 'SKU', field: 'item_id',sortable: false},
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false}]
      }
      else
      {
        this.columns_details = [ 
          {label: 'Location', field: 'location',sortable: false}, 
          {label: 'Name', field: 'product_name',sortable: false},
          {label: 'Processor Type', field: 'processor_type',sortable: false},
          {label: 'Processor Model', field: 'processor_model',sortable: false}]
      }
    },
    backToSov()
    { 
      window.location = '#/sov-summary-amd'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable2').DataTable().destroy();
      this.initCols()
      localStorage.selected_website = this.selected_website
      localStorage.selected_category = this.device
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      let payload = { 
        "website": this.selected_website,
        "timestamp":this.date.startDate,
        "item_category": this.device
      }
      const url = "/api/amazon_india/sov_detail_india"
      this.$http.post(url, payload).then(response => {
        for (let [idx, ds] of  response.body.data.entries())
        {
          if(ds.product_name) ds.product_name = ds.product_name.replace('"','\'').replace('&amp;','&')
       
          if(ds.processor_type.indexOf('amd')!=-1) ds.processor_type = ds.processor_type.replace('amd','AMD')
    
         
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      if (this.date.startDate2)
        this.date.startDate2 = moment(this.date.startDate2).format('YYYY-MM-DD')
    },
    
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          pagingType: "full_numbers",

          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
             
                var select = $('<select><option value="">All</option></select>')
                .appendTo( $(column.footer()).empty() )
                .on( 'change', function () {
                    var val = $.fn.dataTable.util.escapeRegex(
                        $(this).val()
                    );      
    
                    column
                        .search( val ? '^'+val+'$' : '', true, false )
                        .draw();
                } );
                let arr = []    
                let sortedArr = []
                column.data().unique().sort().each( function ( d, j ) {
                  var myVal = $(d).text()
                  arr.push(myVal)
                } ); 
                  
                sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
                
                for (let [idx, ds] of sortedArr.entries())
                {
                  select.append( '<option value="'+ds+'">'+ds+'</option>' )
                } 
          } );
        }
      });
      var searchIcon = require("../../../public/Icons_SVG/Search.svg");
      $("#myTable2_filter > label > input").attr(
        "placeholder",
        "Search"
      );
      $("#myTable2_filter > label").append(
        `<div class='search_icon'><img src='${searchIcon}' /></div>`
      );
      // $("#amdglobal-compliance-sov-detailTable_filter").prepend(`<div class='filter_icon'><img src='${funnel}' /></div>`);
      // $("#amdglobal-compliance-sov-detailTable_filter > div.filter_icon").click(() => this.filterAddAction())
      $("#myTable2_length > label > select").removeClass();
    }
  }
}

</script>



<style scoped>
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem !important;
}
.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1.5rem;
}

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:9
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
input.filval,button.filval{
  border-radius: 0;
  padding: 6px;
  height: 30px;

}
input.filval
{
  padding-top:5px;
}
button.filval
{
  padding-top:3px
}
.filter .row{
  justify-content: center;
}
.filter select, input.filval
{
  border:1px solid silver
}


</style>
